import { useEffect } from "react";

export const useApplyFieldErrors = (fieldErrors, errorClass = "border-red-500") => {
    useEffect(() => {
        const selectors = ["input", "textarea", "select"];

        // Clear previous error classes
        selectors.forEach((selector) => {
            document.querySelectorAll(`${selector}.${errorClass}`).forEach((el) => {
                el.classList.remove(errorClass);
            });
        });

        if (!Array.isArray(fieldErrors)) return;

        fieldErrors.forEach(({ fieldName }) => {
            selectors.forEach((selector) => {
                const el = document.querySelector(`${selector}[name="${fieldName}"]`);
                if (el) {
                    console.log(el)
                    el.classList.add(errorClass);
                }
            })
        });
    }, [fieldErrors, errorClass]);
};